module.exports = __webpack_public_path__ + "img/sq5d_feature_02.6dd46f7f.jpg";